import { TripMediaQuery } from '@website/types/graphqlOperations';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { MdFileDownload } from 'react-icons/md';
import { getImageUrlForDownload } from '../../../media/utils/imgix';

type Props = {
  photos: TripMediaQuery['trip']['media']['items'];
};

export default function MediaDownloadAll({ photos }: Props) {
  // Download modal state
  const [showDownloadingModal, setShowDownloadingModal] = useState(false);

  // Promisify JSZipUtils.getBinaryContent (download the image)
  function urlToPromise(url: string): any {
    return new Promise((resolve, reject) => {
      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  // Onclick handler
  function onClickDownloadAll(small: boolean) {
    const zip = new JSZip();
    const imageFiles = zip.folder('images');

    photos.forEach((image, key) => {
      const url = `${getImageUrlForDownload(
        image.file?.key,
      )}&auto=compress,enhance,redeye&crop=faces&fit=crop&fm=jpg&q=90&dl${
        small ? '&w=1920&ar=1:1' : ''
      }`;
      imageFiles.file(`${key}.jpg`, urlToPromise(url), { binary: true });
    });

    setShowDownloadingModal(true);

    // Generate the zip file asynchronously
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Force down of the Zip file
      saveAs(content, 'archive.zip');
      setShowDownloadingModal(false);
    });
  }

  return (
    <>
      {' '}
      <div className="d-grid gap-2">
        <Button
          style={{ marginTop: 10 }}
          onClick={() => onClickDownloadAll(true)}
        >
          <MdFileDownload /> Download all (for social media)
        </Button>
        <Button
          style={{ marginTop: 10 }}
          onClick={() => onClickDownloadAll(false)}
        >
          <MdFileDownload /> Download All (originals)
        </Button>
      </div>
      <Modal show={showDownloadingModal}>
        <Modal.Header closeButton>
          <Modal.Title>Preparing your download</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Spinner animation="border" size="sm" />
          This may take a few minutes...
        </Modal.Body>
      </Modal>
    </>
  );
}
